import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // ✅ Standaard NL
        fallbackLng: "nl",

        // ✅ Alleen 'nl' en 'en' toestaan
        supportedLngs: ["nl", "en"],

        // ✅ 'en-US' → 'en', 'nl-NL' → 'nl'
        load: "languageOnly",
        nonExplicitSupportedLngs: true,

        debug: false,
        interpolation: { escapeValue: false },

        // ✅ Zorg dat het pad altijd klopt, ook met subpaths
        backend: {
            loadPath: `${process.env.PUBLIC_URL || ""}/locales/{{lng}}/{{ns}}.json`,
        },

        // optioneel, maar duidelijk
        ns: ["translation"],
        defaultNS: "translation",

        detection: {
            order: ["querystring", "localStorage", "navigator"],
            caches: ["localStorage"],
            lookupQuerystring: "lng",
        },
    });

export default i18n;